import { render, staticRenderFns } from "./ForecastsLong.vue?vue&type=template&id=40f65f00&"
import script from "./ForecastsLong.vue?vue&type=script&lang=js&"
export * from "./ForecastsLong.vue?vue&type=script&lang=js&"
import style0 from "./ForecastsLong.vue?vue&type=style&index=0&id=40f65f00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports